import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Training = () => {
    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
            offset: 100,
            easing: 'ease-out-cubic',
        });
    }, []);

    return (
        <>
            {/* Page Header Start */}
            <div className="container-fluid page-header py-5" style={{marginBottom: "6rem"}} data-aos="fade-down">
                <div className="container py-5">
                    <h1 className="display-3 text-white mb-3">Training Services</h1>
                </div>
            </div>
            {/* Page Header End */}

            {/* Introduction Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
                            <div className="position-relative">
                                <img src="img/train-1.webp" className="img-fluid rounded shadow-lg" style={{width: "100", maxWidth: "1000px"}} alt="Training Center"/>
                            </div>
                        </div>
                        
                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay="100">
                            <h6 className="text-primary text-uppercase mb-2">Government Certified Training</h6>
                            <h1 className="display-6 mb-4">Skill Development Programs in Collaboration with Government Initiatives</h1>
                            <p className="mb-4">A2Z Solutions provides comprehensive training services in collaboration with government agencies including KEONICS (Karnataka State Electronics Development Corporation) and under the PM Vishwakarma Scheme. Our training programs are designed to bridge the skill gap and empower individuals with industry-relevant skills for better employment opportunities.</p>
                            
                            <p className="mb-4">We are proud to be an authorized training partner working closely with government initiatives to deliver quality skill development programs that align with national and state-level employment generation goals.</p>
                            
                            <div className="row g-3">
                                <div className="col-sm-6" data-aos="fade-up" data-aos-delay="200">
                                    <div className="d-flex">
                                        <i className="fa fa-university text-primary fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">KEONICS Partner</h5>
                                            <p className="mb-0">State Government Collaboration</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6" data-aos="fade-up" data-aos-delay="300">
                                    <div className="d-flex">
                                        <i className="fa fa-flag text-primary fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">PM Vishwakarma</h5>
                                            <p className="mb-0">Central Government Scheme</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Government Collaboration Section */}
            <div className="container-xxl py-5 bg-light">
                <div className="container">
                    <div className="text-center mb-5" data-aos="fade-up" data-aos-delay="100">
                        <h6 className="text-primary text-uppercase">Government Partnerships</h6>
                        <h1 className="display-6 mb-4">Our Government Training Initiatives</h1>
                    </div>

                    <div className="row g-5">
                        {/* KEONICS Collaboration */}
                        <div className="col-lg-6" data-aos="fade-right" data-aos-delay="150">
                            <div className="bg-white p-4 rounded shadow h-100">
                                <div className="text-center mb-4">
                                    <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "80px", height: "80px" }}>
                                        <i className="fa fa-university fa-3x"></i>
                                    </div>
                                    <h3 className="mb-3">KEONICS Collaboration</h3>
                                </div>
                                
                                <p className="mb-4">A2Z Solutions is proud to collaborate with <strong>KEONICS (Karnataka State Electronics Development Corporation Limited)</strong>, a premier government agency dedicated to promoting electronics and IT industries in Karnataka.</p>
                                
                                <div className="mb-4">
                                    <h5 className="mb-2">Our Training Programs with KEONICS:</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Computer Literacy and Basic IT Skills</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Advanced Software Training Programs</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Digital Literacy for Rural Empowerment</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> E-Governance and Digital India Initiatives</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Electronics and Hardware Training</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> ITES and BPO Skill Development</li>
                                    </ul>
                                </div>

                                <div className="bg-primary-light p-3 rounded">
                                    <p className="mb-0"><strong>Impact:</strong> Through our collaboration with KEONICS, we have trained thousands of individuals across Karnataka, particularly focusing on rural and semi-urban areas, contributing to the state's digital transformation goals.</p>
                                </div>
                            </div>
                        </div>

                        {/* PM Vishwakarma Collaboration */}
                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay="150">
                            <div className="bg-white p-4 rounded shadow h-100">
                                <div className="text-center mb-4">
                                    <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "80px", height: "80px" }}>
                                        <i className="fa fa-flag fa-3x"></i>
                                    </div>
                                    <h3 className="mb-3">PM Vishwakarma Scheme</h3>
                                </div>
                                
                                <p className="mb-4">We are an authorized training partner under the <strong>PM Vishwakarma Scheme</strong>, a flagship initiative by the Government of India aimed at supporting traditional artisans and craftspeople through skill development and entrepreneurship.</p>
                                
                                <div className="mb-4">
                                    <h5 className="mb-2">Training Focus Areas under PM Vishwakarma:</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Traditional Craft Skill Enhancement</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Modern Tools and Technology Training</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Entrepreneurship Development</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Digital Marketing for Artisans</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Quality Certification and Standardization</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Financial Literacy and Business Management</li>
                                    </ul>
                                </div>

                                <div className="bg-primary-light p-3 rounded">
                                    <p className="mb-0"><strong>Objective:</strong> To preserve traditional skills while equipping artisans with modern techniques and business knowledge, enabling them to compete in contemporary markets while maintaining cultural heritage.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="text-center my-5" data-aos="zoom-in" data-aos-delay="700">
                                <img src="img/training-02.jpg" className="img-fluid rounded shadow-lg" alt="Government Training Session" style={{maxHeight: "400px"}}/>
                            </div>

            {/* Training Programs Content Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-12">
                            <h2 className="mb-4" data-aos="fade-up" data-aos-delay="100">Our Government-Supported Training Programs</h2>
                            
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="150">A2Z Solutions offers specialized training programs under government schemes, designed to create sustainable livelihood opportunities and enhance employability across various sectors.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="200">Digital Literacy and Computer Training</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="250">Comprehensive computer literacy programs covering basic computer operations, internet usage, digital payments, and e-governance services. These programs are particularly focused on rural and semi-urban populations to bridge the digital divide and support Digital India initiatives.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="300">Traditional Craft and Artisan Training</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="350">Under the PM Vishwakarma Scheme, we provide specialized training to traditional artisans in areas such as pottery, weaving, metalwork, woodwork, and other heritage crafts. The training includes skill upgradation, modern techniques, quality improvement, and entrepreneurship development.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="400">Technical and Vocational Training</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="450">In collaboration with KEONICS, we offer technical training programs in electronics, electrical work, hardware maintenance, and other vocational skills that are in high demand in the industrial and service sectors.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="500">Entrepreneurship Development Programs</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="550">Comprehensive training programs focusing on business planning, financial management, marketing strategies, and digital presence development. These programs are designed to create successful entrepreneurs who can contribute to local economic development.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="600">Soft Skills and Employability Training</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="650">Training programs focusing on communication skills, workplace etiquette, team collaboration, and problem-solving abilities. These skills are essential for successful employment and career advancement in today's competitive job market.</p>
                            
                            

                            <h2 className="mb-4 mt-5" data-aos="fade-up" data-aos-delay="750">Training Methodology and Support</h2>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="800">Practical and Hands-on Learning</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="850">Our training methodology emphasizes practical, hands-on learning with real tools and equipment. We provide industry-relevant training that prepares participants for actual workplace scenarios and challenges.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="900">Certification and Recognition</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="950">Successful participants receive government-recognized certificates that enhance their employability and credibility. These certificates are valued by employers and institutions across the country.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="1000">Placement Assistance</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="1050">We provide placement assistance to trained candidates, connecting them with potential employers and job opportunities. Our network includes various industries and organizations looking for skilled professionals.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="1100">Post-Training Support and Mentorship</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="1150">Our support continues even after training completion. We offer mentorship, business guidance, and access to resources that help participants implement their skills successfully in employment or entrepreneurship.</p>
                            
                            <div className="bg-light p-4 rounded mt-5" data-aos="fade-up" data-aos-delay="1200">
                                <h4 className="mb-3">Why Choose A2Z Solutions for Government Training Programs?</h4>
                                <p className="mb-3">We are officially recognized as a training partner by government agencies including KEONICS and authorized under the PM Vishwakarma Scheme, ensuring the authenticity and quality of our training programs.</p>
                                
                                <p className="mb-3">Our training programs are designed and delivered by experienced professionals who understand both the traditional skills and modern requirements of various industries.</p>
                                
                                <p className="mb-3">Many of our training programs are subsidized or fully funded by government schemes, making quality skill development accessible to people from all economic backgrounds.</p>
                                
                                <p className="mb-0">We have a proven track record of successfully training thousands of individuals who have gone on to secure employment or start their own businesses. Our focus on practical outcomes ensures that participants gain valuable skills that lead to tangible career opportunities.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Eligibility and Enrollment Section */}
            {/* <div className="container-xxl py-5 bg-light">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
                            <div className="bg-white p-4 rounded shadow">
                                <h3 className="mb-3">Eligibility and Enrollment</h3>
                                <p className="mb-4">Our government-supported training programs are open to individuals meeting specific eligibility criteria as defined by the respective government schemes.</p>
                                
                                <h5 className="mb-2">General Eligibility Criteria:</h5>
                                <ul className="mb-4">
                                    <li className="mb-2">Indian citizens aged 18 years and above</li>
                                    <li className="mb-2">Educational qualifications as specified for each program</li>
                                    <li className="mb-2">Priority given to women, SC/ST candidates, and economically weaker sections</li>
                                    <li className="mb-2">For PM Vishwakarma: Traditional artisans and craftspeople</li>
                                    <li>For KEONICS programs: Residents of Karnataka state</li>
                                </ul>
                                
                                <h5 className="mb-2">Required Documents:</h5>
                                <ul className="mb-0">
                                    <li className="mb-2">Aadhaar Card</li>
                                    <li className="mb-2">Educational Certificates</li>
                                    <li className="mb-2">Caste Certificate (if applicable)</li>
                                    <li className="mb-2">Income Certificate (if applicable)</li>
                                    <li>Recent passport-size photographs</li>
                                </ul>
                            </div>
                        </div>
                        
                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay="100">
                            <div className="bg-white p-4 rounded shadow">
                                <h3 className="mb-3">Program Benefits</h3>
                                <div className="row g-3">
                                    <div className="col-sm-6">
                                        <div className="d-flex">
                                            <i className="fa fa-certificate text-primary fa-2x flex-shrink-0 me-3"></i>
                                            <div>
                                                <h5 className="mb-1">Government Certificate</h5>
                                                <p className="mb-0">Nationally recognized certification</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="d-flex">
                                            <i className="fa fa-rupee-sign text-primary fa-2x flex-shrink-0 me-3"></i>
                                            <div>
                                                <h5 className="mb-1">Financial Support</h5>
                                                <p className="mb-0">Subsidized or free training</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="d-flex">
                                            <i className="fa fa-briefcase text-primary fa-2x flex-shrink-0 me-3"></i>
                                            <div>
                                                <h5 className="mb-1">Placement Assistance</h5>
                                                <p className="mb-0">Job opportunities after training</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="d-flex">
                                            <i className="fa fa-tools text-primary fa-2x flex-shrink-0 me-3"></i>
                                            <div>
                                                <h5 className="mb-1">Toolkit Support</h5>
                                                <p className="mb-0">Essential tools for artisans</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            
            <style jsx>{`
                .page-header {
                    background: linear-gradient(rgba(6, 3, 21, 0.8), rgba(6, 3, 21, 0.8)), 
                                url('img/carousel-01.jpg') no-repeat center center;
                    background-size: cover;
                }
                .bg-primary-light {
                    background-color: rgba(13, 110, 253, 0.1);
                    border-left: 4px solid var(--bs-primary);
                }
            `}</style>
        </>
    );       
}

export default Training;






